import { useState, useEffect } from "react";
import cogoToast from "cogo-toast-react-17-fix";
import { useNavigate } from "react-router-dom";
import RightContent from "../../components/OnBoard/RightContent";
import Menu from "../../components/OnBoard/Menu";
import OtpInputs from "../../Utils/OtpInputs";
import { resetTimer, Timer } from "../../Utils/helper";
import { GET_OTP, VERIFY_OTP } from "../../Utils/constant";
import Error from "../../components/OnBoard/Error";
import Modal from "../../Utils/Modal";
import API from "../../ApiConfig";
import styles from "./UserOnboarding1.module.css";

const Onboarding1 = () => {
  const userData = JSON.parse(localStorage.getItem("user_data"))
  if (userData == null || userData.user_state == "ONBOARDED") {
    return (<Error Message={"Some Error Occured"} />)
  }
  const [mfaOtp, setMfaOtp] = useState("");
  const [Popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isOTPSent = localStorage.getItem('remainingTime') || 0
  const [OtpTimer, setOtpTimer] = useState(0)
  const [OTPkey, setOTPKey] = useState(Date.now())
  const [resetOtp, setResetOtp] = useState(false)
  const GetMfaOtp = (data) => {
    setMfaOtp(data);
  }

  const getOTP = () => {
    let formData = { email:userData.email }
    API.post("api/v1/verifier/signup/resend-otp", { ...formData })
      .then(data => {
        if (data.status == 200) {
          let res = data.data
          setOtpTimer(res.data.otp_expires_in)
          localStorage.setItem('remainingTime', res.data.otp_expires_in * 60)
          localStorage.setItem("savedTimestamp", Date.now());
          cogoToast.success("OTP Sent on " + userData.email);
          setOTPKey(Date.now())

          setResetOtp(prev => !prev);
          setMfaOtp("")
        }
      })
      .catch(err => {

        if (err.response.data.message.includes("ONBOARDED")) {
          cogoToast.info("User already verified")
          navigate("/login")
        } else {
          cogoToast.error(err.response.data.detail[0])
        }
      })
  }

  const getPhone = () => {
    return (
      <div style={{ padding: "1rem", gap: "0.6rem" }}>
        <span className={styles.weMessagedA}>We will be verifying <span className={styles.span}>  {userData.email} </span></span>
        <div className={styles.buttonBase}>
          {/* <button onClick={() => navigate('/app/registration/changePhone')} className={styles.button}>Change</button> */}
          <button onClick={e => { e.preventDefault(); getOTP(); setPopup(false) }} className={styles.button} style={{ background: "var(--primary-700)", color: "white", border: "none" }}>Send OTP</button>
        </div>
      </div>
    )
  }

  useEffect(() => {
    // if (isOTPSent == '0') {
      // setPopup(true);
      resetTimer()
    // }
  }, [])

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state to true
    let otpPayload = { email: userData.email, otp: mfaOtp };
    API.post("api/v1/verifier/signup/verify-otp", otpPayload)
      .then(data => {
        if (data.data.status == 200) {
          cogoToast.success("OTP Verified");
          if (userData.verifier_id) {
            navigate('/app/registration/step4');
          } else {
            navigate('/app/registration/step4');
          }
        } else {
          cogoToast.error("Please check the OTP and try again");
        }
      })
      .catch(err => {
        cogoToast.error(err.response.data.message);
      })
      .finally(() => {
        setIsLoading(false); // Reset loading state
      });
  }

  return (
    <div className={styles.userOnboarding}>
      <RightContent step={2} />
      <form className={styles.leftContent} onSubmit={handleSubmit}>
        <div className={styles.progressForm}>
          <div className={styles.progressForm1}>
            {/* <Menu pos="2" USER={userData.IsVerifier} /> */}
            <div className={styles.form}>
              <div className={styles.form1}>
                <div className={styles.headingHelperText}>
                  <h1 className={styles.heading} style={{fontSize:"30px"}}>Check your email</h1>
                  <div>
                      <p className={styles.supportingText} style={{textAlign:"center"}}>We messaged a 6-digit code to <span><b>{userData.email}</b></span> Enter the code below to verify.</p>
                    {/* <Modal title="Verifying Email" isOpen={Popup} onClose={setPopup} blockOutsideClick={true} children={getPhone()}>

                    </Modal> */}
                  </div>
                </div>
                <div className={styles.emailContainer}>
                  <div><p className={styles.supportingText} style={{textAlign:"center", fontSize:"16px", marginBottom:"3rem"}}>VERIFICATION CODE</p></div>
                <div className={styles.codeInputs}>
                  <OtpInputs length={6} getOtp={GetMfaOtp}  resetTrigger={resetOtp}/>
                </div>
                <Timer m={OtpTimer} getOTP={getOTP} link="/step2" key={OTPkey} />
                {
            mfaOtp ?
              <button type="submit" disabled={isLoading} className="primaryBtn">
                {isLoading ? "Submitting..." : "Verify Account"}
              </button> :
              <button style={{ backgroundColor: "lightgray", cursor: "not-allowed" }} disabled={!mfaOtp || isLoading} className="DisableprimaryBtn">
                {isLoading ? "Submitting..." : "Verify Account"}
              </button>
          }
              </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Onboarding1;
